import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { PrestationContratsAssocies, Prestations } from '../models/prestation.model';
import { Observable } from 'rxjs';
import { TypePrestations } from '../models/type-prestation.model';
import { InlineResponse } from '../models/inline-response.model';
import { TypePrestation } from '../../features/parameters/referentials/referentials-prestations/type-prestation.model';
import { GenericResponse } from '../models/generic-response.model';
import { Prestation } from '../../features/parameters/referentials/referentials-prestations/prestation.model';
import { PrestationRequest } from '../../features/parameters/referentials/referentials-prestations/contrats-associes/prestation--contrats-associes.model';

const options = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json; charset=utf-8',
  }),
};

@Injectable({
  providedIn: 'root',
})
export class PrestationClientService {
  private apiURL = environment.apiURL;

  constructor(private readonly http: HttpClient) {}

  public findPrestations(linkToDechet?: boolean): Observable<Prestations> {
    let params = new HttpParams().append('sord', 'asc').append('sidx', 'designation').append('page', '1').append('rows', '4294967295').append('nd', '1722868437950').append('_search', 'false');

    if (!!linkToDechet) {
      params = params.append('linkedToDechet', linkToDechet);
    }

    return this.http.get<Prestations>(this.apiURL + '/services/prestation/byContrat', { params: params });
  }

  // Type Prestation
  public getAllTypePrestation(): Observable<TypePrestations> {
    return this.http.get<TypePrestations>(this.apiURL + '/services/typeprestation');
  }

  public addTypePrestation(afficherSurLaConfirmation: boolean, codeHecate: number, designation: string, envoiTennaxia: boolean, suffisantPourDemande: boolean, transport: boolean, uniteId?: number): Observable<InlineResponse> {
    let params = new HttpParams()
      .append('designation', designation)
      .append('codeHecate', codeHecate === 0 ? '' : codeHecate)
      .append('suffisantPourDemande', suffisantPourDemande)
      .append('afficherSurLaConfirmation', afficherSurLaConfirmation)
      .append('transport', transport)
      .append('envoiTennaxia', envoiTennaxia);

    if (uniteId != null) {
      params = params.append('uniteId', uniteId);
    }

    params = params.append('id', '')
      .append('oper', 'add');

    return this.http.post<InlineResponse>(this.apiURL + '/services/typeprestation', params);
  }

  public updateTypePrestation(typePrestation: TypePrestation): Observable<InlineResponse> {
    let params = new HttpParams();

    params = params.append('designation', typePrestation.designation);
    if (!!typePrestation.codeHecate) {
      params = params.append('codeHecate', typePrestation.codeHecate);
    }

    params = params.append('suffisantPourDemande', typePrestation.suffisantPourDemande).append('afficherSurLaConfirmation', typePrestation.afficherSurLaConfirmation).append('transport', typePrestation.transport).append('envoiTennaxia', typePrestation.envoiTennaxia);

    if (typePrestation.unite != null) {
      params = params.append('uniteId', typePrestation.unite.id);
    }

    if (typePrestation.id == null || typePrestation.id == 0) {
      params = params.append('id', typePrestation.id);
      params = params.append('oper', 'add');
    } else {
      params = params.append('id', typePrestation.id);
      params = params.append('oper', 'edit');
    }

    return this.http.post<InlineResponse>(this.apiURL + '/services/typeprestation', params);
  }

  // Prestation
  public getAllPrestation(): Observable<Prestations> {
    return this.http.get<Prestations>(this.apiURL + '/services/prestation');
  }

  public addPrestation(categorieAchatMosaic: string | null | undefined, codeDR: string, codeHecate: string, codeTennaxia: string, designation: string, libelleCaracteristiques: string, lienDechet: string, typeId: number): Observable<InlineResponse> {
    let params = new HttpParams();

    if (!!categorieAchatMosaic) {
      params = params.append('categorieAchatMosaic', categorieAchatMosaic);
    }
    params = params.append('codeDR', codeDR);
    params = params.append('codeHecate', codeHecate);
    params = params.append('codeTennaxia', codeTennaxia);
    params = params.append('designation', designation);
    params = params.append('libelleCaracteristiques', libelleCaracteristiques);
    params = params.append('lienDechet', lienDechet);
    params = params.append('typeId', typeId);
    params = params.append('id', '');
    params = params.append('oper', 'add');

    return this.http.post<InlineResponse>(this.apiURL + '/services/prestation', params);
  }

  public updatePrestation(prestation: Prestation): Observable<InlineResponse> {
    let params = new HttpParams()
      .append('categorieAchatMosaic', prestation.categorieAchatMosaic)
      .append('codeDR', prestation.codeDR)
      .append('codeHecate', prestation.codeHecate)
      .append('codeTennaxia', prestation.codeTennaxia)
      .append('designation', prestation.designation)
      .append('libelleCaracteristiques', prestation.libelleCaracteristiques)
      .append('lienDechet', prestation.lienDechet)
      .append('typeCodeHecate', prestation.typeCodeHecate)
      .append('typeDesignation', prestation.typeDesignation)
      .append('typeId', prestation.typeId)
      .append('variante', prestation.variante)
      .append('oper', 'edit');

    if (!!prestation.id) {
      params = params.append('id', prestation.id);
    }

    return this.http.post<InlineResponse>(this.apiURL + '/services/prestation', params);
  }

  public getContratAssocies(prestationId: number): Observable<PrestationContratsAssocies> {
    let params = new HttpParams().set('prestationId', prestationId);

    return this.http.get<PrestationContratsAssocies>(this.apiURL + '/services/v2/prestation/editcontratsassocies', { params: params });
  }

  public saveContratAssocies(prestationRequestAsJSON: string): Observable<GenericResponse> {
    return this.http.post<GenericResponse>(this.apiURL + '/services/v2/prestation/update', { prestationRequestAsJSON }, options);
  }
}
